import type { Statut } from '../../types';

/** Aujourd'hui (jour local, pas UTC) au format 'AAAA-MM-JJ'. */
export function jourLocalIso(d: Date = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// « 09:00:00 » → « 9 h » ; « 14:30:00 » → « 14 h 30 »
function heure(t?: string | null): string {
  const m = t ? /^(\d{1,2}):(\d{2})/.exec(t) : null;
  if (!m) return '';
  return m[2] === '00' ? `${Number(m[1])} h` : `${Number(m[1])} h ${m[2]}`;
}

/** « 14 h », « 14 h 30 » (vide si l'heure est inconnue) */
export function heureCourte(t?: string | null): string {
  return heure(t);
}

/** « 14 h – 16 h » (vide si l'horaire est inconnu) */
export function horaireCourt(debut?: string | null, fin?: string | null): string {
  const a = heure(debut);
  const b = heure(fin);
  return a && b ? `${a} – ${b}` : '';
}

/** Parties d'une date 'YYYY-MM-DD' pour une pastille calendrier : { dow: 'mer.', jour: '11', mois: 'nov.' } */
export function partiesJour(dateISO: string): { dow: string; jour: string; mois: string } {
  const d = new Date(`${String(dateISO).slice(0, 10)}T00:00:00Z`);
  const f = (opts: Intl.DateTimeFormatOptions) => new Intl.DateTimeFormat('fr-CH', { ...opts, timeZone: 'UTC' }).format(d);
  return { dow: f({ weekday: 'short' }), jour: f({ day: 'numeric' }), mois: f({ month: 'short' }) };
}

/** « Absence de Loïse Roubakine » mais « Absence d'Aline Weber » (élision devant une voyelle ou un h). */
export function absenceDe(nom?: string | null): string {
  if (!nom) return 'Absence';
  return /^[aeiouyhàâäéèêëîïôöùûüœ]/i.test(nom) ? `Absence d'${nom}` : `Absence de ${nom}`;
}

/** Où en est la recherche, dit à un·e collègue (« externe » n'apparaît jamais). */
export function etatRecherche(statut: Statut): { libelle: string; classe: '' | 'relance' | 'gest' | 'urg' } {
  switch (statut) {
    case 'recherche_interne_1': return { libelle: 'Recherche · 1er appel', classe: '' };
    case 'recherche_interne_2': return { libelle: 'Relance', classe: 'relance' };
    case 'urgence_cascade': return { libelle: 'Urgent', classe: 'urg' };
    case 'recherche_externe':
    case 'fusion_demandee':
    case 'evaluation_annulation': return { libelle: "L'équipe gestion cherche aussi", classe: 'gest' };
    default: return { libelle: '', classe: '' };
  }
}
